import { render, staticRenderFns } from "./PinMyCom.vue?vue&type=template&id=6fb151fe&scoped=true&"
import script from "./PinMyCom.vue?vue&type=script&lang=js&"
export * from "./PinMyCom.vue?vue&type=script&lang=js&"
import style0 from "./PinMyCom.vue?vue&type=style&index=0&id=6fb151fe&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb151fe",
  null
  
)

export default component.exports